<template>
    <div id="projects-sidebar-menu" class="sidebar-menu-container">
        <div class="sidebar-main-label">Группировка</div>
        <div class="groups-container">
    <!--            Эл-т с v-show необходим, чтобы при изменении selectedGroupID в url, вызывался перерендер компонента
    и св-во colorFieldWidth перерасчитывалось для каждой группы заново-->
            <div v-show="false">{{selectedGroupID}}</div>
            <div class="groups-grid" v-for="(group, key) in planeGroupList" v-on:click="selectGroup(key)"
                 v-on:dblclick="editSelectedGroup(key)">
                <div class="groups-grid-element" v-bind:style="{
                    'background-color': group.color,
                    'width': colorFieldWidth(key),
                }">
                </div>
                <div class="groups-grid-element" v-bind:style="{
                    'color': groupNameColor(key)
                }">
                    {{group.name}}
                </div>
            </div>
        </div>
        <div class="add-group-button" v-on:click="addPlaneGroup()">
            + Добавить группу
        </div>
    </div>
</template>

<script>
    export default {
        name: "GroupingSidebarMenu",
        components: {

        },
        computed: {
            selectedGroupID() {
                const group = this.$store.state.route.params.groupID;
                if (group) {
                    return group
                } else {
                    return null
                }
            },
            planeGroupList() {
                return this.$store.getters["active/PLANE_GROUP_LIST"];
            }
        },
        methods: {
            colorFieldWidth(groupID) {
                if (groupID == this.selectedGroupID) {
                    return '15px'
                } else {
                    return '5px'
                }
            },
            groupNameColor(groupID) {
                if (groupID == this.selectedGroupID) {
                    return '#AD0C27'
                }
            },
            selectGroup(groupID) {
                this.$router.replace({name: 'groupingPlanesActive',
                    params: {groupID: groupID},
                    query: this.$route.query}).catch(err=>{});
            },
            async addPlaneGroup() {
                const groupID = await this.$store.dispatch('active/CREATE_PLANE_GROUP', {});
                this.$router.push({name: 'groupingPlanesActiveEditGroup',
                    params: {groupID: groupID},
                    query: this.$route.query}).catch(err=>{});
            },
            editSelectedGroup() {
                this.$router.push({
                    name: 'groupingPlanesActiveEditGroup',
                    query: this.$route.query,
                }).catch(() => {});
            }
        },
    }
</script>

<style scoped>
    @media screen and (max-height: 800px) {
        .groups-grid {
            font-size: 14px;
        }
        .add-group-button {
            font-size: 14px;
        }
        .groups-container {
            margin: 20px 0 0 0;
        }
    }

    @media screen and (min-height: 800px) {
        .groups-grid {
            font-size: 18px;
        }
        .add-group-button {
            font-size: 18px;
        }
        .groups-container {
            margin: 40px 0 0 0;
        }
    }

    .groups-grid {
        display: grid;
        grid-template-columns: max-content auto;
        grid-column-gap: 10px;
        color: #555555;
        margin: 7px 0;
        cursor: pointer;
        user-select: none;
    }

    .groups-grid-element:hover {
        color: #AD0C27;
    }

    .add-group-button {
        color: #555555;
        margin: 15px 0;
        cursor: pointer;
        user-select: none;
    }

    .add-group-button:hover {
        color: #AD0C27;
    }
</style>
